import type { Difficulty } from "./types.js";
import { DIFFICULTIES } from "./types.js";

export const LAUNCH_DATE = "2025-12-05";

/**
 * Date from which day-of-week difficulty applies.
 * Puzzles before this date use "medium" to preserve determinism.
 */
export const DIFFICULTY_START_DATE = "2026-03-30";

export function makeDailySeed(date: string, size: string): string {
  return `gridlock-${date}-${size}`;
}

/**
 * Get the difficulty level for a given date based on day-of-week.
 * Sunday (0) = chill, Monday (1) = easy, ... Saturday (6) = brutal.
 * Dates before DIFFICULTY_START_DATE return "medium" for backward compatibility.
 */
export function getDifficultyForDate(date: string): Difficulty {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || date < DIFFICULTY_START_DATE) return "medium";
  const day = new Date(date + "T00:00:00Z").getUTCDay();
  return DIFFICULTIES[day];
}
